import {
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    SelectChangeEvent,
    Box,
    Skeleton,
} from "@mui/material";
import { FC, useEffect, useState } from "react";
import CommonDialog from "../CommonDialog/CommonDialog";
import { useTranslation } from "../../../explorer/hooks/useTranslation";
import { useApiError } from "../../hook/useApiError";
import ServiceProvider from "../../configuration/ServiceProvider";
import { CustomerUserDto } from "../../../explorer/types/SpareParts/CustomerUserDto";
import useBrands from "../../../explorer/hooks/useBrands";

type TBasketTransferDialog = {
    open: boolean;
    handleCloseTransferDialog: () => void;
    handleTransferDialog: (username: string) => void;
};

const BasketTransferDialog: FC<TBasketTransferDialog> = (props) => {
    const { open, handleCloseTransferDialog, handleTransferDialog } = props;
    const { t } = useTranslation();

    const [items, setItems] = useState<CustomerUserDto[]>([]);
    const [value, setValue] = useState<string>("");
    const [loading, setLoading] = useState<boolean>(true);

    const [error, setError] = useApiError();
    const brand = useBrands().currentBrandUrl;

    const handleChange = (event: SelectChangeEvent) => {
        if (event) setValue(event.target.value.toString());
    };

    useEffect(() => {
        if (open === true) {
            setLoading(true);
            ServiceProvider.SpareParts.getUsersToTransfer(brand)
                .then((response) => {
                    setItems(response);
                    setLoading(false);
                })
                .catch((error) => {
                    console.error(error);
                    setError(error?.data?.title);
                });
        }
    }, [open]);

    const denyTransferDialog = () => {
        setValue("");
        handleCloseTransferDialog();
    };

    const confirmTransferDialog = () => {
        if (!value) setError("Select a username");
        else {
            handleTransferDialog(value);
            setValue("");
        }
    };

    return (
        <CommonDialog
            open={open}
            dialogTitleLabel={"basket.TransferBasket"}
            //dialogContentLabel={"basket.TransferTo"}
            closeDialog={denyTransferDialog}
            confirmButton={confirmTransferDialog}
            disableConfirmBtn={value === ""}
            confirmButtonText={"common.Transfer"}
        >
            <FormControl fullWidth>
                {loading ? (
                    <Skeleton />
                ) : items.length > 0 ? (
                    <>
                        <InputLabel id="input_label_transfer_user">
                            {t("basket.TransferTo")}
                        </InputLabel>
                        <Select
                            labelId="input_label_transfer_user"
                            id="input_select_transfer_user"
                            label={t("TransferTo")}
                            value={value}
                            onChange={handleChange}
                            variant="standard"
                        >
                            {items.map((x, idx: number) => (
                                <MenuItem key={idx} value={x.userName}>
                                    {x.firstName + " " + x.lastName} 
                                </MenuItem>
                            ))}
                        </Select>
                    </>
                ) : (
                    <Box sx={{fontSize: 14,}}>{t("basket.transfer.noUsers")}</Box>
                )}
            </FormControl>
        </CommonDialog>
    );
};
export default BasketTransferDialog;
